import React from "react";
import { useSelector } from "react-redux";
import { getClientId } from "@microdoing/shared/services/user/selectors";
import algoliasearch from "algoliasearch";
import { InstantSearch, Configure } from "react-instantsearch-native";
import { Box } from "app/components/common";

const searchClient = algoliasearch(
  "MTMFJ78PRC",
  "a6400a80c85f1dcceaaddde616c096a3",
);

interface IProps {
  children: React.ReactElement;
  style: {};
}

const AlgoliaSearch = ({ children, style }: IProps) => {
  const clientId = useSelector(getClientId);

  return (
    <Box
      flex={1}
      width="100%"
      alignItems="center"
      justifyContent="center"
      backgroundColor="neutral.white"
      testID="search-screen"
      style={style}
    >
      <InstantSearch searchClient={searchClient} indexName={clientId}>
        <Configure filters="type:user" />
        {children}
      </InstantSearch>
    </Box>
  );
};

export default AlgoliaSearch;
